var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.723 20.3a.948.948 0 0 1-.275-.7c0-.283.092-.516.275-.7l9.55-9.55c-.3-.7-.341-1.491-.125-2.375.217-.883.692-1.675 1.425-2.375.884-.883 1.867-1.4 2.95-1.55 1.084-.15 1.967.117 2.65.8.684.684.95 1.567.8 2.65-.15 1.084-.666 2.067-1.55 2.95-.7.734-1.491 1.209-2.375 1.425-.883.217-1.675.175-2.375-.125L13.423 12l6.9 6.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7c-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3l-6.9-6.85-6.9 6.85c-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3Zm3.65-7.85-3-3c-.75-.75-1.187-1.625-1.312-2.625A4.47 4.47 0 0 1 3.623 4a.93.93 0 0 1 .75-.475c.334-.033.625.084.875.35l5.325 5.375-3.2 3.2Z",
    fill: "#7AC4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipesIcon);
export default __webpack_public_path__ + "static/media/recipes-icon.ef68c9f38a364e9c109fae05d898fe0b.svg";
export { ForwardRef as ReactComponent };